import { useTimeStore } from './time'
import { defineStore } from 'pinia'

export const useSubscriptionStore = defineStore({
    id: 'subscription',

    state () {
        return {
            token: null,
            access: null,
            subscription: null,
            subscribed: false,
            hadAccess: false,
            trialAvailable: false,

            hydrated: false
        }
    },

    getters: {
        trialVisible (state) {
            const time = useTimeStore();
            let tokenExpired = !state.token;

            if (state.token && state.token.end) {
                tokenExpired = new Date(state.token.end) < time.now;
            }

            return state.trialAvailable && tokenExpired;
        },

        expired (state) {
            const time = useTimeStore();

            if (!state.token || !state.token.end) return false;
            return new Date(state.token.end) < time.now;
        }
    },

    actions: {
        async hydrate() {
            let data = await this.$nuxt.$axios.$get('/access/checkstatus/', {
                progress: false
            })
            .catch((err) => {
                console.log(err);
                this.hydrating = false;
            });

            if (data?.token) this.token = data.token;

            if (data?.payment) {
                this.subscribed = data.payment.status == 'subscribed';
            } else {
                this.subscribed = false;
            }

            if (data && ('hadAccess' in data)) {
                this.hadAccess = data.hadAccess;
            }

            if (data && ('trialAvailable' in data)) {
                this.trialAvailable = data.trialAvailable;
            }

            if (data && ('access' in data)) {
                this.access = data.access;
            }
            
            this.hydrated = true;
        },

        setToken(token) {
            this.token = token;
            this.subscription = token.access;
        }
    }
})
